import { useAuth0 } from "@auth0/auth0-react";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import ExportSvgComponent from "assets/icons/svg/exportFilter";
import PrintSvgComponent from "assets/icons/svg/print";
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoField";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import { useSearch } from "hook";
import FinanceService from "Lib/API/Finance";
import MemberService from "Lib/API/Member";
import { PayAll } from "pages/Members/MemberDetails/finance/PayAll";
import { PaymentStatus } from "pages/Members/MemberDetails/finance/PaymentStatus";
import React, { useEffect, useState } from "react";
import CsvDownloader from "react-csv-downloader";
import { toastr } from "react-redux-toastr";
import DateRange from "./dateRangeComponent";
import { sanitizeRows } from "utils/exportSanitize";

const PaymentRequestFilter = ({ selected, status, ...props }) => {
  const [open, setOpen] = React.useState(false);
  const [startDate, setStartDate] = useState("");
  const [search, setSearch] = useState(undefined);
  const [list, setList] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [filter, setFilter] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [toPay, setToPay] = useState([]);
  const { searchAction } = useSearch({ action: setSearch });
  const [loading, setLoading] = useState(false);
  const [contactsList, setContactsList] = React.useState([]);
  const [cards, setCards] = useState([]);
  const [showStatus, setShowStatus] = useState(false);
  const [pStatus, setPStatus] = useState("");
  const accountId = props?.value?.account_id;
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  useEffect(() => {
    const arr = [];
    if (!props.value) setToPay([]);
    if (selected && props.value)
      selected.map((item) => {
        if (list)
          list.map((row) => {
            if (row.id === item) arr.push(row);
          });
        setToPay(arr);
      });
  }, [selected, props.value]);
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  ///////////////////////////////////////////////////////////////////////
  /////////////////////////////GET CARDS ///////////////////////////////
  React.useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getCardsById(accountId, token)
        .then((res) => {
          if (res) {
            setLoading(false);
            setCards(res);
          }
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);

        });
    }
    if (accountId) fetchMyAPI();
  }, [accountId]);
  ///////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////
  useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const input = {
        filter: {
          status: "Unpaid",
          member_id: props?.value?.value,
          from_date: startDate,
          to_date: endDate,
          min_amount: minAmount,
          max_amount: maxAmount,
        },
      };
      FinanceService.getFilterdPaymentRequests(input, token)
        .then((res) => {
          if (res?.payRequests) {
            res.payRequests.map((item) => {
              item.id = item._id;
              return item;
            });
            props.setMemberRequests(res.payRequests);
            setList(res.payRequests);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    if (props.value || filter || minAmount || minAmount) fetchMyAPI();
  }, [props.value, filter, minAmount, maxAmount, props.refresh]);
  ///////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////
  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      await MemberService.getContacts(token, search).then((res) => {
        if (res?.contacts) {
          res.contacts.map((item) => {
            item.id = item.member_id;
            item.label = item?.first_name + " " + item?.last_name;
            item.value = item._id;
            return item;
          });
          setContactsList(res?.contacts);
        }
        setLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }

    fetchMyAPI();
  }, [search]);

  const getData = () => {
    const arr = [];
    list.forEach((item) => {
      const d = {
        pay_req_id: item.pay_req_id,
        date: item.due_date,
        invoice_number: item.invoice_id?.inv_id,
        name: item.member_id?.first_name + " " + item.member_id?.last_name,
        amount: item.payment_amount,
      };
      arr.push(d);
    });
    return arr;
  };

  return (
    <div className="activated-ledger">
      <div className="bar d-flex justify-content-between">
        <div className="sub-header-functions">
          <AsyncAutoCompleteField
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            options={contactsList}
            className="w-250px mr-5"
            placeholder="Select a Member..."
            isLoading={loading}
            handleChange={props.setValue}
            value={props.value}
            style={{ background: "#ffff" }}
          />
          <DateRange
            setFilter={setFilter}
            endDate={endDate}
            startDate={startDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            open={open}
            setOpen={setOpen}
          />
          <button
            className="date-button"
            onClick={() => {
              setFilter(false);
              setOpen(true);
            }}
          >
            <span className="pl-2">Date Range</span>
            <CalendarTodayOutlinedIcon />
          </button>
          <div className="d-flex ml-5 p-0 align-items-baseline">
            <p>Amount</p>
            <input
              className="mx-5"
              style={{
                width: "7rem",
                borderRadius: "6px",
                border: "none",
                height: "45px",
                background: "#ffff",
              }}
              id="min_amount"
              name="min_amount"
              type="number"
              onKeyDown={(e) => preventArrows(e)}
              placeholder="Min"
              onChange={(event) => {
                setMinAmount(event.target.value.match(regex)[0]);
              }}
              value={minAmount}
            />
            -
            <input
              className="mx-5"
              style={{
                width: "7rem",
                borderRadius: "6px",
                border: "none",
                height: "45px",
                background: "#ffff",
              }}
              id="max_amount"
              name="maxn_amount"
              type="number"
              onKeyDown={(e) => preventArrows(e)}
              placeholder="Max"
              onChange={(event) => {
                setMaxAmount(event.target.value.match(regex)[0]);
              }}
              value={maxAmount}
            />
          </div>
        </div>
        <div className={status === "paid" ? "d-none" : "options"}>
          {props.value && selected?.length != 0 ? (
            <MyButton
              style={{ height: "auto", marginRight: "10px" }}
              type={"primary"}
              content={"Pay"}
              onClick={() => {
                setOpenModal(true);
              }}
            />
          ) : (
            ""
          )}
          <div className="svg-filters">
            <CsvDownloader
              filename="EazyTemple"
              extension=".csv"
              columns={props.colToCsv?.map((item) => {
                return { id: item.field, displayName: item.headerName };
              })}
              datas={sanitizeRows(getData())}
            >
              <ExportSvgComponent /> <span>Export</span>
            </CsvDownloader>
          </div>
          <div
            className="svg-filters"
            onClick={() => {
              props.setPrintClicked(true);
            }}
          >
            <PrintSvgComponent /> <span>Print</span>
          </div>
          {!props.payLoading && (
            <MyModal
              open={openModal}
              onClose={() => {
                setOpenModal(false);
              }}
            >
              <PayAll
                setPayLoading={props.setPayLoading}
                data={toPay}
                cards={cards}
                refresh={props.efresh}
                setRefresh={props.setRefresh}
                selectionModel={selected}
                setPayAllPop={setOpenModal}
                setShowStatus={setShowStatus}
                setStatus={setPStatus}
              />
            </MyModal>
          )}
        </div>
      </div>
      <AlertDialog
        open={showStatus}
        handleClose={() => setShowStatus(false)}
        content={"Are you sure?"}
        subContent={<PaymentStatus status={pStatus} />}
        removeButton={true}
      />
    </div>
  );
};

export default PaymentRequestFilter;
